import React, { useContext, useMemo, useRef, useState } from "react";
import { Alert, Spin, Tabs } from "antd";
import useRMateChart from "./useRMateChart";
import Axios from "axios";
import ChartPane from "./ChartPane";
import MapPropsContext from "../MapPropsContext";
import { processForChart1, processForChart2, getChart1Layout, getChart2Layout } from "./RMateChartStatsStationUtils";
import { getApiHost } from "../../../utils";
import useDebounce from "../../../utils/hooks/useDebounce";
import StyledTableHeader from "../../../styled-components/StyledTableHeader";
import { StyledButton } from "../../../styled-components/Button";
import { TI_MODAL_RESULT_CLOSE_BUTTON } from "../../../Constants";

const PRM_CHECK_LABELS_DICT = {
  32: "기지국",
  94: "간이무선국",
  44: "육상무선국",
  85: "이동중계국",
  49: "이동국",
  92: "아마추어국",
  42: "의무선박국",
  41: "선박국",
  21: "고정국",
  CMFL: "전파응용설비",
  OTHER: "기타",
};

function RMateChartStatsStation({ disabled }) {
  const { chartAjaxParams, chartDivVisible } = useContext(MapPropsContext);

  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [parsedObject, setParsedObject] = useState({});
  const [prevParams, setPrevParmas] = useState({});
  const {
    sidoCode,
    searchStart,
    searchEnd,
    searchChk, // 기간조회 = Y
    chkRadClsString,
    prmCheckList,
  } = chartAjaxParams;

  const PRM_CHECK = prmCheckList || [];
  const PRM_CHECK_LABEL = useMemo(() => {
    return PRM_CHECK.map((prmCheck) => PRM_CHECK_LABELS_DICT[prmCheck]);
  }, [PRM_CHECK]);

  useDebounce(
    () => {
      if (isInit) {
        // const url = DEBUG
        //   ? '/viewYearByClsByStats-sample.json'
        //   : '/rwdinfolabstats/getYearByClsBySm.do.json';
        const url = getApiHost() + "/rwdinfolabstats/getYearByClsBySm.do.json";
        const params = {
          sidoCode,
          searchStart,
          searchEnd,
          searchChk,
          chkRadClsString,
        };

        // 비교년월의 차이가 올바른 경우 chartDivVisible : false
        if (chartDivVisible === false && JSON.stringify(params) !== JSON.stringify(prevParams)) {
          setPrevParmas(params);
          setIsLoading(true);
          setError(null);
          setParsedObject({}); // 초기화

          Axios.get(url, { params })
            .then(({ data }) => {
              const { itemSm, itemSm10 } = data;
              const chart1Data = processForChart1(itemSm);
              const { minYear, maxYear, chart2Data } = processForChart2(itemSm10);
              setParsedObject({ chart1Data, chart2Data, minYear, maxYear });
            })
            .catch((e) => {
              console.error(e);
              setError(e);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    },
    1000,
    [isInit, chartAjaxParams, setIsLoading, setParsedObject]
  );

  const { chart1Data, chart2Data } = parsedObject;
  const [tabType, setTabType] = useState("number");

  return useRMateChart({
    init: () => setIsInit(true),
    style: { minHeight: "540px" },
    disabled,
    children: (
      <div style={{ position: "relative", height: "100%" }}>
        {/*{isLoading && <Spin style={{ position: 'absolute', left: '50%', top: '50%', zIndex: 1 }} size={"large"}/>}*/}
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: 55,
              zIndex: 1,
              height: "90%",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{ height: "470px" }}
              />
            </Spin>
          </div>
        )}
        <div style={{ padding: "4px" }}>
          <StyledButton
            isActive={tabType === "number"}
            style={{ borderRadius: "4px 0px 0px 4px" }}
            onClick={() => setTabType("number")}
            tabIndex={TI_MODAL_RESULT_CLOSE_BUTTON - 2}
          >
            {chartDivVisible === false ? `국종별 무선국 수 (${getLabelForYearMonth(searchEnd)})` : `국종별 무선국 수`}
          </StyledButton>
          <StyledButton
            isActive={tabType === "change"}
            style={{ borderRadius: "0px 4px 4px 0px" }}
            onClick={() => setTabType("change")}
            tabIndex={TI_MODAL_RESULT_CLOSE_BUTTON - 1}
          >
            국종별 무선국 변동
          </StyledButton>
        </div>
        {error && <Alert type={"error"} message={"오류가 발생했습니다."} />}
        {tabType === "number" && (
          <ChartPane
            data={chart1Data}
            processor={() => chart1Data}
            layoutProcessor={
              searchEnd && chartDivVisible === false && (() => getChart1Layout(PRM_CHECK, PRM_CHECK_LABEL, searchEnd))
            }
            style={chart1Data && chart1Data.length > 16 ? { height: chart1Data.length * 30 } : { height: 510 }}
          />
        )}
        {tabType === "change" && (
          <ChartPane
            data={chart2Data}
            processor={() => chart2Data}
            layoutProcessor={
              searchEnd &&
              chartDivVisible === false &&
              (() => getChart2Layout(PRM_CHECK, PRM_CHECK_LABEL, searchStart, searchEnd, searchChk))
            }
            style={
              chart2Data && chart2Data.length > 23
                ? { height: 510, width: chart2Data.length * 30 }
                : { height: 510, width: "100%" }
            }
          />
        )}
        {/* <Tabs defaultActiveKey={"1"} type={"card"}>
          <Tabs.TabPane
            tab={
              chartDivVisible === false
                ? `국종별 무선국 수 (${getLabelForYearMonth(searchEnd)})`
                : `국종별 무선국 수`
            }
            key={"1"}
          >
            {error && <Alert type={"error"} message={"오류가 발생했습니다."} />}
            <ChartPane
              data={chart1Data}
              processor={() => chart1Data}
              layoutProcessor={
                searchEnd &&
                chartDivVisible === false &&
                (() => getChart1Layout(PRM_CHECK, PRM_CHECK_LABEL, searchEnd))
              }
              style={
                chart1Data && chart1Data.length > 16
                  ? { height: chart1Data.length * 30 }
                  : { height: 510 }
              }
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={`국종별 무선국 변동`} key={"2"}>
            {error && <Alert type={"error"} message={"오류가 발생했습니다."} />}
            <ChartPane
              data={chart2Data}
              processor={() => chart2Data}
              layoutProcessor={
                searchEnd &&
                chartDivVisible === false &&
                (() =>
                  getChart2Layout(
                    PRM_CHECK,
                    PRM_CHECK_LABEL,
                    searchStart,
                    searchEnd,
                    searchChk
                  ))
              }
              style={
                chart2Data && chart2Data.length > 23
                  ? { height: 510, width: chart2Data.length * 30 }
                  : { height: 510, width: "100%" }
              }
            />
          </Tabs.TabPane>
        </Tabs> */}
      </div>
    ),
  });
}

const getLabelForYearMonth = (yearMonth) => {
  if (yearMonth) {
    if (yearMonth.length === 4) {
      return `${yearMonth}년`;
    } else if (yearMonth.length === 6) {
      return `${parseInt(yearMonth.substr(0, 4))}년`;
    }
  }
  return yearMonth;
};

window.chartLabelYear = function (index, value) {
  console.log(value);
  if (value.length === 4 && Number.isInteger(Number(value))) {
    return '<font size="15">' + value + "년</font>";
  } else if (value.length === 6 && Number.isInteger(Number(value))) {
    return '<font size="15">' + value.substring(4, 6) + "월</font>";
  } else {
    return '<font size="15">' + value + "</font>";
  }
};

export default RMateChartStatsStation;
